import React, { useEffect, useRef } from 'react';
import { InlineError, Req } from './Fields';

let scriptPromise = null;
const loadScript = () => {
  if (window.grecaptcha) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
      s.async = true; s.defer = true;
      s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  return scriptPromise;
};

const RecaptchaBox = ({ siteKey, onToken, error, resetKey }) => {
  const box = useRef(null);
  const widget = useRef(null);
  useEffect(() => {
    let cancelled = false;
    loadScript().then(() => {
      window.grecaptcha.ready(() => {
        if (cancelled || widget.current !== null || !box.current) return;
        widget.current = window.grecaptcha.render(box.current, { sitekey: siteKey, callback: onToken, 'expired-callback': () => onToken('') });
      });
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [siteKey, onToken]);
  useEffect(() => { if (widget.current !== null && window.grecaptcha) { window.grecaptcha.reset(widget.current); onToken(''); } }, [resetKey, onToken]);
  return (
    <div id="ob-captcha" className="py-3 px-3" data-testid="ob-field-captcha">
      <label className="block text-[16px] text-white mb-1.5">Please verify that you are human<Req /></label>
      <div ref={box} data-testid="ob-recaptcha" />
      <InlineError msg={error} id="captcha" />
    </div>
  );
};

export default RecaptchaBox;
